import { render, staticRenderFns } from "./ReceptionVerificationInjection.vue?vue&type=template&id=0fb67e6a"
import script from "./ReceptionVerificationInjection.vue?vue&type=script&lang=js"
export * from "./ReceptionVerificationInjection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports